const SNAP_APP_SUFFIX = '_snap_app';

export function removeSnapAppSuffix(input: string) {
  return input.replace(SNAP_APP_SUFFIX, '');
}

export function appendSnapAppSuffix(input: string) {
  return `${input}${SNAP_APP_SUFFIX}`;
}
